import dynamic from 'next/dynamic';
import { createGlobalStyle } from 'styled-components';

import { useDevice } from '@contexts/device';
import { HotelEventsViewModel } from '@api/v3';

const DesktopEvents = dynamic(() => import('./DesktopEvents'));
const MobileEvents = dynamic(() => import('./MobileEvents'));

const HotelListingEventsTooltipStyles = createGlobalStyle`

& .rc-tooltip-arrow {
  border-top-color: ${({ theme }) => theme.palette.NL0};
}

`;

type Props = {
  events: HotelEventsViewModel[];
};

const HotelListingEvents = ({ events }: Props) => {
  const { isDesktop } = useDevice();

  return (
    <>
      <HotelListingEventsTooltipStyles />
      {isDesktop ? (
        <DesktopEvents events={events} />
      ) : (
        <MobileEvents events={events} />
      )}
    </>
  );
};

export default HotelListingEvents;
